import ConsumerRoutePath from 'app/consumer-app/ConsumerRoutePath';
import { Address } from 'app/core/api/company/api-company.types';
import {
  useUpdateUserProfile,
  useUserProfile,
} from 'app/core/api/user/api-user';
import Button from 'app/shared/components/button/Button';
import FetchifyAddressForm, {
  DetailedAddress,
} from 'app/shared/components/fetchify-address/FetchifyAddressForm';
import { useObservableSend } from 'app/tools/hooks/misc-hooks';
import { tap } from 'rxjs/operators';
import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useShowInfo } from 'app/shared/context-hooks/use-show-info.hook';
// import { tap } from 'rxjs';

export default function UserAddressEntry(): JSX.Element {
  const history = useHistory();

  const { resource: userInfo, loading } = useUserProfile();
  const { request$: updateUserInfo$, sending } =
    useUpdateUserProfile();

  const { showSnack } = useShowInfo();

  // TODO: remove when api endpoint address shape matches business address
  const reshapedAddress = useMemo<Partial<Address>>(
    () => ({
      addrLine1: userInfo?.address1,
      addrLine2: userInfo?.address2,
      city: userInfo?.city,
      postcode: userInfo?.postcode,
      country: userInfo?.country,
    }),
    [userInfo]
  );

  const [sendFormCommand, formCommand$] =
    useObservableSend<'submit'>();

  const submit = (data: DetailedAddress) =>
    updateUserInfo$({
      address1: data.addrLine1,
      address2: data.addrLine2,
      city: data.city,
      postcode: data.postcode,
      country: data.country.code,
    }).pipe(
      tap(() => {
        showSnack({
          message: 'Address Updated!',
          alertType: 'success',
        });
        history.push(`${ConsumerRoutePath.PROFILE}`);
      })
    );

  return (
    <>
      <FetchifyAddressForm
        searchPlaceholder={
          loading
            ? 'Search... '
            : userInfo?.postcode
            ? 'Search for a new address here'
            : 'Start with post/zip code or street'
        }
        editable={!loading}
        defaultValues={reshapedAddress}
        onSubmit={submit}
        command$={formCommand$}
      />
      <Button
        onClick={() => sendFormCommand('submit')}
        disabled={loading}
        pending={sending}
      >
        Save
      </Button>
    </>
  );
}
